<mat-dialog-content class="!grid">
  <p class="dialog-title">Importante</p>
  <hr class="dialog-divider" />
  <p>Debe confirmar la acción para terminar el tema.</p>
</mat-dialog-content>
<mat-dialog-actions class="!justify-end">
  <button
    class="uppercase-button"
    mat-raised-button
    [mat-dialog-close]="false"
    tabindex="-1">
    CANCELAR
  </button>
  <button mat-flat-button [color]="'primary'" (click)="terminarTemaDespacho()">
    CONFIRMAR
  </button>
</mat-dialog-actions>
